// Layouts
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";

// MUI
import { Stack } from "@mui/material";

// Types
import { ITiers, IPartialError, IArrayError, IOnActionUpdateArgs, IOnChangeTypeArgs, ISpace } from "../../../types/sections/technicians";

type MatrixRowProps = {
	index: number;
	item: ITiers;
	fromDisabled: boolean;
	toDisabled: boolean;
	spaces: ISpace;
	rowsErrors?: IPartialError[];
	columnsErrors?: IArrayError[];
	readOnly: boolean;
	spacing?: number | string;
	mainContentProps?: Object;
	sxMainContent?: Object;
	cellsProps?: Object;
	sxCells?: Object;
	firstInputDataProp: any;
	secondInputDataProp: any;
	onChangeType: (params: IOnChangeTypeArgs) => void;
	onChangeTypeHeader: (params: IOnChangeTypeArgs) => void;
	onActionUpdate: (params: IOnActionUpdateArgs) => void;
};

export default function MatrixRow(props: MatrixRowProps) {
	const {
		index = 0,
		item = null,
		fromDisabled = false,
		toDisabled = false,
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 1,
			totalRows: 1,
			separation: 5.5,
		},
		rowsErrors = [],
		columnsErrors = [],
		readOnly = false,
		spacing = "0.8",
		mainContentProps = null,
		sxMainContent = {
			minWidth: "190px",
		},
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "180px",
		},
		firstInputDataProp,
		secondInputDataProp,
		onChangeType,
		onChangeTypeHeader,
		onActionUpdate,
	} = props;
	const hasOneBonusOnly = spaces?.totalColumns === 1 && spaces?.totalRows === 1;

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={sxMainContent}>
					<DoubleInput
						firstInput={{
							data: firstInputDataProp,
							sx: { width: "95px" },
							defaultType: item?.from?.input || "Duration",
							value: item?.from?.value || 0,
							error: Boolean(rowsErrors?.[index]?.from),
							disabled: fromDisabled,
							readOnly: true,
							onChangeType: (_, input) => {
								onChangeTypeHeader?.({ row: index, location: "row", area: "commission", input });
							},
						}}
						secondInput={{
							data: secondInputDataProp,
							sx: { width: "95px" },
							defaultType: item?.to?.input || "Duration",
							value: item?.to?.value || 0,
							error: Boolean(rowsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.({ row: index, column: 0, location: "row", area: "to", value });
							},
							onChangeType: (_, input) => {
								onChangeTypeHeader?.({ row: index, location: "row", area: "commission", input });
							},
							readOnly,
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{item?.commissions?.map((element, key) => {
						const indexKey = `commissions_input_${key}`;
						return (
							<Stack key={indexKey} {...cellsProps} sx={sxCells}>
								<InputFormExtension
									data={[
										{
											type: "Duration",
											min: 0,
											max: 744,
											decimals: 2,
											decimalsEditable: true,
											exact: true,
										},
										{
											type: "Dollar",
											min: 0,
											max: 100000000,
											decimals: 2,
											decimalsEditable: true,
										},
										{
											type: "Duration per Unit",
											min: 0,
											max: 744,
											decimals: 2,
											decimalsEditable: true,
											exact: true,
										},
										{
											type: "Dollar per Duration",
											min: 0,
											max: 100000,
											decimals: 2,
											decimalsEditable: true,
										},
									]}
									value={element?.commission?.value || 0}
									defaultType={element?.commission?.input || "Duration"}
									error={Boolean(columnsErrors?.[index]?.[key]?.["commission"])}
									disabled={readOnly || hasOneBonusOnly}
									onChangeType={(_, input) => {
										onChangeType?.({ row: index, column: key, location: "row", area: "commission", input });
									}}
									onActionUpdate={(value) => {
										onActionUpdate?.({
											row: index,
											column: key,
											location: "row",
											area: "commission",
											value: value as number,
										});
									}}
									sx={{
										width: "95px",
									}}
								/>
							</Stack>
						);
					})}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
}
